import React, { FC } from "react";
import styles from "./flex.module.scss";

const Flex: FC = ({ children }) => (
	<div className={styles.flex}>{children}</div>
);

export default Flex;
